export default "__VITE_ASSET__DM3J5D9D__"